import * as i0 from '@angular/core';
import * as i1 from './table.module';
import * as i2 from './cell';
import * as i3 from './row';
import * as i4 from '../bidi/bidi.module';
import * as i5 from '../platform/platform.module';
export const NbTableModuleNgFactory:i0.NgModuleFactory<i1.NbTableModule> = (null as any);
var _decl0_0:i1.NbTable<any> = (<any>(null as any));
var _decl0_1:i2.NbHeaderCellDefDirective = (<any>(null as any));
var _decl0_2:i3.NbHeaderRowDefDirective = (<any>(null as any));
var _decl0_3:i2.NbColumnDefDirective = (<any>(null as any));
var _decl0_4:i2.NbCellDefDirective = (<any>(null as any));
var _decl0_5:i3.NbRowDefDirective<any> = (<any>(null as any));
var _decl0_6:i2.NbFooterCellDefDirective = (<any>(null as any));
var _decl0_7:i3.NbFooterRowDefDirective = (<any>(null as any));
var _decl0_8:i3.NbDataRowOutletDirective = (<any>(null as any));
var _decl0_9:i3.NbHeaderRowOutletDirective = (<any>(null as any));
var _decl0_10:i3.NbFooterRowOutletDirective = (<any>(null as any));
var _decl0_11:i3.NbCellOutletDirective = (<any>(null as any));
var _decl0_12:i2.NbHeaderCellDirective = (<any>(null as any));
var _decl0_13:i2.NbCellDirective = (<any>(null as any));
var _decl0_14:i2.NbFooterCellDirective = (<any>(null as any));
var _decl0_15:i3.NbHeaderRowComponent = (<any>(null as any));
var _decl0_16:i3.NbRowComponent = (<any>(null as any));
var _decl0_17:i3.NbFooterRowComponent = (<any>(null as any));
var _decl0_18:i4.NbBidiModule = (<any>(null as any));
var _decl0_19:i5.NbPlatformModule = (<any>(null as any));
var _decl0_20:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_21:i0.ElementRef<any> = (<any>(null as any));
function _View_NbTable_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_NbTable_1_0():void {
  var _any:any = (null as any);
}
function _View_NbHeaderRowComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_NbHeaderRowComponent_2_0():void {
  var _any:any = (null as any);
}
function _View_NbRowComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_NbRowComponent_3_0():void {
  var _any:any = (null as any);
}
function _View_NbFooterRowComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_NbFooterRowComponent_4_0():void {
  var _any:any = (null as any);
}
